import React from 'react'
import { Helmet } from 'react-helmet'
import { fillUrlParamsExceptPage } from '../utils'

const HeaderPagination = ({ urlPage, urlProps, maxPage }) => {
  const page = parseInt(urlProps.page, 10)

  const url = fillUrlParamsExceptPage(urlPage, urlProps)

  return (
    <Helmet>
      {page < maxPage && (
        <link href={url.replace(':page', page + 1)} rel='next' />
      )}
      {page > 1 && <link href={url.replace(':page', page - 1)} rel='prev' />}
    </Helmet>
  )
}

export default HeaderPagination
